import { Component, Input } from '@angular/core';
import { AbstractAttendanceTimelineDirective } from '@directives/abstract-attendance-timeline.directive';
import { Event } from 'src/app/queries/generated';

@Component({
  selector: 'lv-attendance-timeline-event',
  styleUrls: ['attendance-timeline-event.component.scss'],
  template: ''
})
export class AttendanceTimelineEventComponent extends AbstractAttendanceTimelineDirective {
  @Input() event: Event;

  protected getItemTimestamp(): number {
    return new Date(this.event.createdAt).getTime();
  }
}
